import script from "./Interior.vue?vue&type=script&setup=true&lang=js"
export * from "./Interior.vue?vue&type=script&setup=true&lang=js"

import "./Interior.vue?vue&type=style&index=0&id=184a6263&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184a6263"]])

export default __exports__